export const environment = {
  production: false,
  apiUrl: 'https://api.bumaapp.com/api',
  appName: 'InventarioApp',
  version: '1.0.0'
};
